<template>
  <div class="tree-wrap">
    <div class="project-selector">
      <el-select size="mini" style="width: 160px" v-model="jurisdictionId" filterable placeholder="选择架构"
                 class="kuan" @change="checkedGetList">
        <el-option v-for="item in jurisdictionList" :key="item.id" :label="item.department_name"
                   :value="item.id">
        </el-option>
      </el-select>
      <el-button size="mini" @click="refreshTree" type="success">重置</el-button>
    </div>

    <div class="el-tree-1" :style="{height:height}">
      <el-tree ref="tree" :data="tree_list" :empty-text="emptyText" :props="defaultProps" :lazy="true"
               :load="getData" @node-click="nodeClick"></el-tree>
    </div>
  </div>
</template>

<script>
import Http from "../common/Http";

export default {
  name: "HrTree",
  props:{
    height:{
      type:String,
      default:()=>"calc(100vh - 150px)",
    }
  },
  data(){
    return {
      jurisdictionId: '',
      jurisdictionList:[],
      tree_list:[],
      emptyText: '没有数据',
      defaultProps: {
        children: '',
        label: 'department_name'
      },
    }
  },
  mounted() {
    this.getDepartmentList()
  },
  methods:{
    //部门全部list
    getDepartmentList(params) {
      var that=this;
      Http.get('hr/department/getDepartmentList', params,res=>{
        if (res.code === 0) {
          that.tree_list = res.data;
          that.jurisdictionList = res.data;
        } else {
          that.$message.error({
            message: res.msg,
            type: "error",
          });

        }
      })

    },
    //单选部门list
    checkedGetList(params) {
      var that=this;
      Http.get("hr/department/getDepartmentList",{
        parent_id: params,
      },res=>{
        if (res.code === 0) {
          that.tree_list = res.data;
        }
        else {
          that.$message.error({
            message: res.msg,
            type: "error",
          });

        }
      })
    },

    //刷新右边树
    refreshTree() {
      this.myGetList();
      this.jurisdictionId = [];

    },

    //节点下面的数据
    getData(node, resolve) {
      //console.log(node.level, node.data)
      var region_id = node.data.id;//选中节点id
      // console.log(region_id);
      var _this = this;
      setTimeout(() => {
        //节点不能为空
        if (region_id == '' || region_id == undefined) {
          return false;
        }
        //加载
        node.data.region_id = region_id;

        node.data && Http.get('hr/department/getDepartmentList', { parent_id: node.data.id, }, backdata => { // 异步执行成功后
          return resolve(backdata.data);
        });
      }, 300);

    },

    //点击树形节点+搜索  = 输出表格
    nodeClick(data, node) {
      this.$emit('nodeClick', data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.el-tree-1 {
  overflow-y: scroll;
  height: calc(100vh - 150px);
  width: 100%;
}
.tree-wrap {
  margin-top: 5px;
  width: 100%;
}

.project-selector {
  margin-bottom: 10px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Personnel/components/HrTree.vue